const ingredientElements = document.getElementsByClassName("ingredient-wrapper");

Array.from(ingredientElements).forEach((button, index) => {
  const minusIcon = button.querySelectorAll("svg.icon-minus")[0];
  minusIcon.classList.add("hidden");
  
  button.addEventListener("click", function () {
    const itemDescription = this.querySelectorAll(
      "p.ingredient-item-description"
    )[0];
    const plusIcon = this.querySelectorAll("svg.icon-plus")[0];
    const minusIcon = this.querySelectorAll("svg.icon-minus")[0];
    
    if (itemDescription.classList.contains("hidden")) {
      itemDescription.classList.remove("hidden");
      plusIcon.classList.add("hidden");
      minusIcon.classList.remove("hidden");
    } else {
      itemDescription.classList.add("hidden");
      minusIcon.classList.add("hidden");
      plusIcon.classList.remove("hidden");
    }
  });
});
